import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID;

export function GoogleAnalytics() {
  const location = useLocation();
  
  useEffect(() => {
    if (!GA_TRACKING_ID || GA_TRACKING_ID === 'G-XXXXXXXXXX') return;
    
    // Load GA4 script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script);
    
    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_TRACKING_ID, {
      'anonymize_ip': true,
      'cookie_expires': 63072000, // 2 years
    });
    
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  
  // Track page views on route change
  useEffect(() => {
    if (!GA_TRACKING_ID || GA_TRACKING_ID === 'G-XXXXXXXXXX' || !window.gtag) return;
    
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);
  
  return null;
}

// Helper function to track custom events
export function trackEvent(eventName, params = {}) {
  if (!window.gtag) return;
  
  window.gtag('event', eventName, {
    ...params,
    timestamp: new Date().toISOString(),
  });
}

// Track bot-related events
export function trackBotEvent(action, botId, params = {}) {
  trackEvent(`bot_${action}`, {
    bot_id: botId,
    ...params,
  });
}

// Track marketplace events
export function trackMarketplaceEvent(action, params = {}) {
  trackEvent(`marketplace_${action}`, params);
}

export default GoogleAnalytics;
